'use client';

import dynamic from 'next/dynamic';
import type { ChartData } from './HistoricalWeatherChart';

const HistoricalWeatherChart = dynamic(() => import('./HistoricalWeatherChart'), {
  ssr: false,
  loading: () => (
    <div className="bg-slate-800/50 p-4 md:p-6 rounded-xl shadow-xl dark:border dark:border-slate-700 flex flex-col">
      <div className="h-6 w-64 rounded bg-slate-700/40 mb-6 animate-pulse" />
      <div
        className="flex-grow min-h-[300px] rounded bg-slate-700/25 animate-pulse"
        aria-busy="true"
      />
    </div>
  ),
});

export default function HistoricalWeatherChartLazy({
  className = '',
  data,
}: {
  className?: string;
  data: ChartData[];
}) {
  return <HistoricalWeatherChart className={className} data={data} />;
}
